import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AddTransactionComp  from "./Component/AddTransactionComp"

const AddTransaction =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AddTransactionComp />
        </div>
        <Footer />
        </>
    )
}

export default AddTransaction